import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TheoreticalMachineBuilder } from '../../models/builders/theoretical-machine.builder';
import { TheoreticalMachine } from '../../models/theoretical-machine';
import { mapCollection } from '../../utils/collection.utils';
import { getErrorHandlingOptions } from '../base/headers';

const theoreticalMachineBody = (theoreticalMachine: TheoreticalMachine) => ({
  code: theoreticalMachine.code,
  name: theoreticalMachine.name,
  description: theoreticalMachine.description,
  workingModelGroupHash: theoreticalMachine.workingModelGroupHash || null,
  active: theoreticalMachine.active,
  // La posicion en el array es la prioridad de escalado.
  escalationHashes: mapCollection((link: TheoreticalMachine) => link.hash, theoreticalMachine.escalation)
});

@Injectable()
export class TheoreticalMachineApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }theoretical-machines`;
  }

  getTheoreticalMachines() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(TheoreticalMachineBuilder.fromList)
      );
  }

  getTheoreticalMachine(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(TheoreticalMachineBuilder.fromJson)
      );
  }

  createTheoreticalMachine(theoreticalMachine: TheoreticalMachine) {
    return this.httpClient.post(this.apiUrl, theoreticalMachineBody(theoreticalMachine))
      .pipe(
        map(TheoreticalMachineBuilder.fromJson)
      );
  }

  updateTheoreticalMachine(theoreticalMachine: TheoreticalMachine) {
    return this.httpClient.put(`${ this.apiUrl }/${ theoreticalMachine.hash }`, theoreticalMachineBody(theoreticalMachine));
  }

  deleteTheoreticalMachine(theoreticalMachine: TheoreticalMachine) {
    return this.httpClient.delete(`${ this.apiUrl }/${ theoreticalMachine.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/theoretical-machine-api.service.ts